<template>
  <div class="modal about-modal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">About</h5>
          <button
            type="button"
            class="modal__close close"
            data-dismiss="modal"
            aria-label="Close"
            @click="$emit('closeModal')"
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <p>
            <strong>{{about.version}}</strong>
          </p>
          <p v-html="about.text"></p>
          <!-- <p>
            <strong>GSSC Now 0.2.0</strong>
          </p> -->
          <!-- <p class="copyright">© European Space Agency, 2019, 2020, 2021, 2022.</p>
          <p>
            <strong>
              GSSC is ESA GNSS Science Support Centre Exploitation
              Platform.
            </strong>
          </p>
          <p>
            The purpose of GSSC is to support collaboration and research across
            scientific communities through the provision of science-based
            information products and services regarding GNSS Infrastructures.
          </p> -->
          <button
            class="btn btn-primary float-right"
            data-dismiss="modal"
            @click="$emit('closeModal')"
          >OK</button>
        </div>
        <div class="modal-footer"></div>
      </div>
    </div>
  </div>
</template>

<script>
import * as api from '@/lib/api'
export default {
  data() {
    return {
      about: {
        version: '',
        text: ''
      }
    }
  },
  async mounted() {
    const response = await api.getAbout()
    this.about = response
    console.log('about',response)
  }

}
</script>

<style lang="scss" scoped>
@import "~@/styles/globals";
.copyright {
  font-size: 12px;
  font-weight: bold;
  color: $deep-space-1;
}
.modal-content {
  border-radius: $border-radius;
  overflow: hidden;
}
</style>>

</style>